.hoverMenuWrapper {
  position: relative;
}

.hoverMenu {
  position: absolute;
  top: -4px; /* Align with the parent element text */
  left: calc(100% + 10px); /* Position to the right of the parent */
  background-color: var(--brand-blue-400);
  background-color: light-dark(var(--brand-blue-400), var(--brand-grey-700));
  border-radius: 4px;
  border: 1px solid light-dark(transparent, var(--brand-grey-500));
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: max-content;
  padding: 8px;
  z-index: var(--z-index-secondary-nav);
  opacity: 0;
  visibility: hidden;
  transform: translateX(-20px);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    visibility 0.3s ease;
  /* Add padding to create a larger hover target area */
  margin-left: 5px;
}

/* Use a more specific selector to ensure this takes precedence */
.hoverMenuWrapper:hover .hoverMenu {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.hoverMenuHeading {
  color: white;
  font-size: var(--font-size-s);
  font-weight: 600;
  font-variant: small-caps;
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 1px;
  user-select: none;

  margin-bottom: 8px;
  padding: 4px 8px;
}

.hoverMenuLinks {
  padding: 4px 0;
}
